import { useHistory } from 'react-router-dom'
import { useRegistrationData } from 'hooks/queries/users/useRegistrationData'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'
import { useAuth } from 'hooks/UseAuth'
import { useFlow } from 'flows/common/hooks/useFlow'

import { onboardingSteps } from '../onboarding/steps'
import { brandKitSteps } from '../brandKitCreation/steps'
import { firstCreationSteps } from '../firstCreation/firstCreationSteps'
import { StepDefinition } from 'flows/common/types'
import { useModals } from 'almanac-ui/Modal'
import { useOnboard } from 'hooks/queries/useOnboard'

const skipToDone = (steps: StepDefinition[]) => steps.map((s) => (s.skipAllowed ? { ...s, skipTarget: 'done' } : s))

export const useOnboardingAndBrandKitFlow = () => {
  const history = useHistory()
  const auth = useAuth()
  const { closeAllModals } = useModals()
  const { mutateAsync: onboard } = useOnboard()
  const { data: reg } = useRegistrationData()
  const { data: kits } = useBrandKits({ enabled: !!auth })

  const computeStart = () => {
    if (!auth) return 'marketingExperience'
    if (!auth.onboarded && !reg?.user_registration_data?.marketing_experience_level) return 'marketingExperience'
    if (!auth.onboarded && !kits?.length) return 'brandKitInstructions'
    if (!auth.onboarded) return 'brandKitColors'
    return 'marketingExperience'
  }

  const handleComplete = async () => {
    await onboard()
    history.push('/')
    closeAllModals()
  }

  return useFlow({
    id: 'onboardingAndBrandKit',
    steps: [...onboardingSteps, ...skipToDone(brandKitSteps), ...skipToDone(firstCreationSteps)],
    fetchInitialData: async () => ({
      auth,
      regData: reg?.user_registration_data ?? null,
      brandKit: kits?.[0] ?? null,
      initialState: computeStart(),
    }),
    onComplete: handleComplete,
  })
}
